import Button from './src/Button';

export default Button;
